import { Field } from 'Util/Query';

class AttributeQuery {
    getAttributeByCode(attributeCode) {
        return new Field('customAttributeMetadata')
            .addArgument('attributes', '[AttributeInput!]!', [{
                attribute_code: attributeCode,
                entity_type: 'catalog_product' }
            ])
            .addField(this.aggregateFields());
    }

    aggregateFields() {
        return new Field('items')
            .addFieldList([
                'attribute_code',
                'attribute_type',
                'entity_type',
                'input_type',
                new Field('attribute_options')
                    .addFieldList([
                        'label',
                        'value'
                    ])
            ]);
    }
}

export default AttributeQuery;
